import stringify from 'fast-json-stable-stringify';
import { customAlphabet } from 'nanoid';
import stringHash from 'string-hash';

// import

const chars = '0123456789' + 'abcdefghijklmnopqrstuvwxyz' + 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
const charLen = chars.length;
const validRx = /^[\dA-Za-z]+$/;
const dateLen = 7; // fns

const hash = v => stringHash(stringify(v));

const encodeAsChars = num => {
  let res = ''; // eslint-disable-next-line fp/no-loops

  while (num > 0) {
    res = chars[num % charLen] + res;
    num = Math.floor(num / charLen);
  }

  return res;
}; // class


class Id {
  constructor(idLength) {
    this.idLength = 12;
    this.idLength = idLength != null ? idLength : this.idLength;
  }

  isId(v) {
    return typeof v === 'string' && v.length === this.idLength && validRx.test(v);
  }

  getNanoId() {
    return customAlphabet(chars, this.idLength)();
  }

  getDateId(dt) {
    encodeAsChars(dt ? new Date(dt).getTime() : Date.now());
    return encodeAsChars(dt ? new Date(dt).getTime() : Date.now()).padStart(dateLen, '0').slice(0, this.idLength).concat(customAlphabet(chars, this.idLength - dateLen)());
  }

  getHashId(v) {
    return encodeAsChars(hash(v)).slice(0, this.idLength).padStart(this.idLength, '0');
  }

}

const createGenerator = len => new Id(len); // export


const id = createGenerator();
const isId = id.isId.bind(id);
const getNanoId = id.getNanoId.bind(id);
const getDateId = id.getDateId.bind(id);
const getHashId = id.getHashId.bind(id);

export { createGenerator, getDateId, getHashId, getNanoId, hash, isId };
//# sourceMappingURL=index.module.js.map
